/* eslint-disable */
import React, { Component } from 'react';
import { View, Dimensions } from 'react-native';
import Animated from 'react-native-reanimated';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  goToTopic,
  lockDrawer,
  setScrollTab,
  goToPage,
} from 'modules/navigation/navigation.actions';
import { TabView } from 'react-native-tab-view';
import { DrawerGestureContext } from 'react-navigation-drawer';
import { TabViewContext } from './discoverTabContext';
import TabBar from './TabBar';
import Discover from './discover.container';
import DiscoverHeader from './discoverHeader.component';
import CommunityList from 'modules/community/communityList.container';
import { getRoutes, routes } from '../utils';

class DiscoverTabs extends Component {
  static propTypes = {
    navigation: PropTypes.object,
    tabId: PropTypes.number,
    actions: PropTypes.object,
    topics: PropTypes.bool,
    tags: PropTypes.object,
  };

  static navigationOptions = ({ navigation }) => {
    const { routeName, tabIndex } = navigation.state;
    const disabled = routeName === 'discoverTag' && tabIndex > 0;
    const isLocked = tabIndex > 0;
    return {
      title: 'Communitites',
      gestureEnabled: !disabled,
      drawerLockMode: isLocked ? 'locked-closed' : 'unlocked',
    };
  };

  tabView = React.createRef();
  header = React.createRef();
  position = new Animated.Value(0);

  state = {
    index: 0,
    headerHeight: 50,
    routes: getRoutes(),
    loaded: false,
  };

  componentDidMount() {
    const { navigation } = this.props;
    const { index } = this.state;

    const { params } = this.props.navigation.state;
    const topicId = params?.topic ? params.id : null;

    if (topicId) {
      this.needsReload = new Date().getTime();
      requestAnimationFrame(() => {
        this.setState({ loaded: true });
      });
    } else {
      this.setState({ loaded: true });
    }
    navigation.setParams({ tabIndex: index });
  }

  componentDidUpdate(prev, prevState) {
    const { tabKey } = this.props;
    const tabId = routes.findIndex((t) => t.key === tabKey);
    if (tabId !== prevState.index && tabKey !== prev.tabKey)
      this.setState({ index: tabId });

    const { index } = this.state;
    const prevIndex = prevState.index;
    if (index !== prevIndex) this.header?.current?.showHeader();
  }

  onScroll = (event) => this.header.current.onScroll(event);

  setPostTop = (height) => this.setState({ headerHeight: height });

  handleChangeTab = (index) => {
    const { actions, navigation } = this.props;
    this.setState({ index });
    const { key } = routes[index];
    actions.setScrollTab('discover', { view: key });
    navigation.setParams({ tabIndex: index });
  };

  renderScene = ({ route }) => {
    const { index, headerHeight, loaded } = this.state;
    const { navigation } = this.props;
    const currentRoute = routes[index] || {};
    if (!loaded) return <View key={route.key} />;
    return (
      <Discover
        active={currentRoute.key === route.key}
        type={route.key}
        key={route.key}
        navigation={navigation}
        onScroll={this.onScroll}
        offsetY={headerHeight}
        tabLabel={route.title}
      />
    );
  };

  renderHeader = (props) => {
    return (
      <DiscoverHeader ref={this.header} setPostTop={this.setPostTop}>
        <TabBar setTab={(index) => this.setState({ index })} {...props} />
      </DiscoverHeader>
    );
  };

  render() {
    const { gesture } = this.props;

    const { auth } = this.props;
    const { community } = auth;

    if (!community) return <CommunityList />;

    return (
      <View style={{ flex: 1 }}>
        <TabViewContext.Provider value={this.tabView}>
          <DrawerGestureContext.Consumer>
            {(ref) => (
              <View style={{ flex: 1 }}>
                <TabView
                  gestureHandlerProps={{
                    ref: this.tabView,
                    simultaneousHandlers: [ref, gesture || {}],
                    waitFor: [gesture || {}],
                  }}
                  renderTabBar={(props) => this.renderHeader(props)}
                  position={this.position}
                  navigationState={this.state}
                  renderScene={this.renderScene}
                  onIndexChange={this.handleChangeTab}
                  initialLayout={{ width: Dimensions.get('window').width }}
                />
              </View>
            )}
          </DrawerGestureContext.Consumer>
        </TabViewContext.Provider>
      </View>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    tags: state.tags,
    tabKey: state.navigation.discover.view,
    topics: state.navigation.showTopics,
    feedUnread: state.posts.feedUnread,
    gesture: state.navigation.gesture,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        goToTopic,
        setScrollTab,
        goToPage,
        lockDrawer,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DiscoverTabs);
